{
    "name": "camps",
    "version": "0.0.0",
    "license": "MIT",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build": "ng build",
        "build-dev": "ng build -c=dev --aot=true --output-hashing=bundles --base-href /Camps.Office/",
        "build-prod": "ng build -c=production",
        "build:docker": "ng build -c=docker --output-hashing=bundles"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "21.2.22",
        "@angular/common": "21.2.22",
        "@angular/compiler": "21.2.22",
        "@angular/compiler-cli": "21.2.22",
        "@angular/core": "21.2.22",
        "@angular/forms": "21.2.22",
        "@angular/platform-browser": "21.2.22",
        "@angular/platform-browser-dynamic": "21.2.22",
        "@angular/router": "21.2.22",
        "@angular/service-worker": "21.2.22",
        "@azure/msal-angular": "6.0.3",
        "@azure/msal-browser": "5.18.0",
        "@bayclubs/alert": "13.0.0",
        "@bayclubs/drop-down": "13.0.0",
        "@bayclubs/employee-auth": "^20.0.2",
        "@bayclubs/horizon": "0.9.2",
        "@bayclubs/logging": "10.0.0",
        "@bayclubs/payments-processor-office-api": "3.14.0",
        "@bayclubs/payments-processor-office-launcher": "0.8.1",
        "@bayclubs/spinner": "13.0.0",
        "@bayclubs/ui-core": "4.0.0",
        "@bayclubs/ui-date-picker": "8.0.0",
        "@bayclubs/ui-icons": "4.0.0",
        "@bayclubs/ui-text-mask": "4.0.0",
        "@bayclubs/ui-time-picker": "4.0.0",
        "@bayclubs/utils": "13.0.0",
        "@grafana/faro-web-sdk": "^2.7.1",
        "@ngx-translate/core": "18.0.0",
        "@ngx-translate/http-loader": "18.0.0",
        "@ngxs/devtools-plugin": "21.0.0",
        "@ngxs/router-plugin": "21.0.0",
        "@ngxs/storage-plugin": "21.0.0",
        "@ngxs/store": "21.0.0",
        "bootstrap": "4.3.1",
        "chart.js": "2.9.3",
        "file-saver": "2.0.2",
        "font-awesome": "4.7.0",
        "guid-typescript": "^1.0.9",
        "jquery": "3.4.1",
        "lodash": "^4.17.15",
        "moment": "2.30.1",
        "moment-timezone": "0.6.3",
        "ngx-bootstrap": "21.2.2",
        "ngx-device-detector": "11.0.0",
        "ngx-infinite-scroll": "21.0.0",
        "ngx-mask": "21.1.0",
        "ngx-toastr": "20.0.5",
        "ngx-ui-switch": "16.1.0",
        "ngx-uploader": "16.0.0",
        "rxjs": "7.8.2",
        "stacktrace-js": "2.0.1",
        "text-mask-addons": "3.8.0",
        "tslib": "2.8.1",
        "zone.js": "0.16.2"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "21.2.23",
        "@angular/cli": "21.2.23",
        "@types/node": "22.18.6",
        "popper.js": "1.14.7",
        "sass": "1.69.2",
        "typescript": "5.9.3"
    }
}
